module.exports = __webpack_public_path__ + "static/jkt_pttn-0aedf77c6949ff2a87f3b1ce54fc2322.pdf";